export default __webpack_public_path__ + "static/media/trusted-by-millions.b9d68f4c.svg";